<template>
    <div class="background-window" @click.self="closeWindow">
        <div class="window-param">
            <div class="head-window">
                <h2 class="name-window-param middle-high">{{nameWinow}}</h2>
                <button @click="closeWindow">
                    <img src="@/assets/imgs/crosser-black.svg" alt="">
                </button>
            </div>
            <div class="body-window">
                <el-form :model="form" label-width="auto" style="max-width: 600px">

                    <!-- Name -->
                    <el-form-item :label="'Наименование компрессора:'">
                        <el-input v-model="form.name" :disabled="userOptions.role != 'developer' && userOptions.role != 'admin'"/>
                    </el-form-item>

                    <!-- Compressor type  -->
                    <el-form-item :label="'Тип:'">
                        <el-input v-model="form.type_controller" disabled />
                    </el-form-item>

                    <!-- MAC address -->
                    <el-form-item :label="'MAC адрес:'">
                        <el-input v-model="form.mac" disabled />
                    </el-form-item>

                    <!-- Date creating -->
                    <el-form-item :label="'Дата регистрации:'">
                        <el-input v-model="form.date" disabled />
                    </el-form-item>

                    <!-- Modem MAC address -->
                    <el-form-item :label="'MAC адрес модема:'">
                        <el-input v-model="form.modem_mac" disabled>
                            <template #suffix>
                                <img 
                                    v-if="userOptions.role == 'developer' || userOptions.role == 'admin'" 
                                    style="cursor: pointer;
                                        margin-left: 4px;
                                        padding-left: 0.5%;
                                        width: 16px;
                                    "
                                    @click="goToModem" 
                                    src="@/assets/imgs/quation.png"
                                >
                            </template>
                        </el-input>
                    </el-form-item>

                    <!-- Sim operator -->
                    <el-form-item v-if="!wifi_mode" :label="'Оператор сим:'">
                        <el-input v-model="form.sim_operator" disabled />
                    </el-form-item>

                    <!-- Sim signal -->
                    <el-form-item v-if="!wifi_mode" :label="'Сигнал sim, %:'">
                        <el-input v-model="form.sim_quality" disabled />
                    </el-form-item>

                    <!-- WiFi spot -->
                    <el-form-item v-if="wifi_mode" :label="'WiFi точка:'">
                        <el-input v-model="form.wifi_ssid" disabled />
                    </el-form-item>

                    <!-- WiFi signal -->
                    <el-form-item v-if="wifi_mode" :label="'Уровень сигнал, %:'">
                        <el-input v-model="form.wifiSignal" disabled />
                    </el-form-item>

                    <!-- User manual -->
                    <el-form-item v-if="!wifi_mode" :label="'Руководство пользователя:'">
                        <el-button 
                            v-if="userOptions.role != 'developer' && userOptions.role != 'admin'"
                            @click="downloadManual"
                            size="small"
                            type="primary"
                            style="margin-left: 5px"
                            plain
                        >download ⤓</el-button>
                        <div class="uploading-downloading-form" v-if="userOptions.role == 'developer' || userOptions.role == 'admin'">
                            <input type="file" ref="myFiles" name="file">
                            <el-button size="small" type="success" @click="uploadFile" plain>upload ↥</el-button>
                            <el-button size="small" type="primary" @click="downloadManual" style="margin-left: 0" plain>download ⤓</el-button>
                        </div>
                    </el-form-item>

                    <!-- Company -->
                    <el-form-item v-if="userOptions.role == 'developer' || userOptions.role == 'admin'" :label="'Название компании:'">
                        <el-select
                            v-model="form.companyId"
                            placeholder="Select"
                            filterable
                            size="small"
                        >
                            <el-option
                                v-for="item in companySmartList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="userOptions.role == 'developer' || userOptions.role == 'admin'">
                        <el-button type="danger" @click="dialogDeleteCompressorVisible = true">Удалить компрессор</el-button>
                    </el-form-item>
                    <el-form-item v-if="userOptions.role != 'demo'">
                        <el-button type="primary" @click="postData">Применить</el-button>
                        <el-button @click="closeWindow">Отменить</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        
        <el-dialog v-model="dialogDeleteCompressorVisible" title="Удаление компрессора" width="500">
            <el-input v-model="tempDeleteLine" placeholder='Напишите "удалить", чтобы продолжить.' />
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="cancelDelete">Отменить</el-button>
                    <el-button type="danger" :disabled="tempDeleteLine != 'удалить'" :loading="deleteLoading" @click="deleteCompressor">
                    Удалить
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "WindowParam",
    emits: ['closeWindow', 'goToModem'],
    props: [
        'id', 'mac', 'nameCompressor', 'date', 'company_id', 'type_controller', 'modem_mac', 'modem_id', 'sim_quality', 'sim_operator',
        'wifi_mode', 'wifi_ssid', 'wifi_rssi'
    ],
    data() {
        return {
            name: '',
            nameWinow: '',
            companyName: '',
            companyId: 0,
            dialogDeleteCompressorVisible: false,
            deleteLoading: false,
            tempDeleteLine: '',
            fileManualUploading: [],
            form: {
                name: '',
                type_controller: '',
                mac: '',
                date: '',
                modem_mac: '',
                sim_operator: '',
                sim_quality: 0,
                wifi_ssid: '',
                wifiSignal: 0,
                companyId: 0
            }
        }
    },
    watch: {
        dialogDeleteCompressorVisible(newFlag) {
            if (newFlag===false) {
                this.tempDeleteLine = '';
            }
        }
    },
    computed: {
        nameWindow() {
            if (this.nameCompressor) {
                return this.nameCompressor
            } else {
                return this.mac
            }
        },
        companySmartList() {
            if (this.userOptions.role == 'admin' || this.userOptions.role == 'developer') {
                return this.companyList.filter(el=> {
                    if (el.dealer_id == this.dealerId || el.id == 0) {
                        return true
                    } else {
                        return false
                    }
                })
            } else {
                return this.companyList
            }
        },
        wifiSignal() {
            if (this.wifi_rssi) {
                return Math.min(Math.max(((this.wifi_rssi - (-100)) * 100) / ((-50) - (-100)), 0), 100);
            } else {
                return ''
            }
        },
        ...mapGetters('user', {
            userOptions: 'getUserOptions',
        }),
        ...mapGetters('compressor', {
            companyList: 'getCompanyList',
        }),
    },
    methods: {
        
        ...mapActions('compressor', {
            setCompressorSettings: 'putCompressorSettings',
            deleteApiCompressor: 'deleteCompressorSettings',
            getCompanyList: 'getApiCompanyList',
            uploadManual: 'postUploadManual',
            apiDownloadManual: 'getDownloadManual',
        }),

        cancelDelete() {
            this.dialogDeleteCompressorVisible = false;
        },
        async deleteCompressor() {
            this.deleteLoading = true;
            await this.deleteApiCompressor(this.id);
            this.deleteLoading = false;
            this.dialogDeleteCompressorVisible = false;
        },
        closeWindow() {
            this.$emit('closeWindow')
        },
        changeDealerClick(opt) {
            this.companyId = 0
        },
        postData() {
            let options = {
                name: this.form.name,
                id: this.id,
                company_id: this.form.companyId
            }
            this.setCompressorSettings(options)
            this.closeWindow()
        },
        goToModem() {
            this.$emit('goToModem', this.modem_id)
        },
        uploadFile() {
            if (this.$refs.myFiles.files.length == 1) {
                const formData = new FormData();
                formData.append('bytes', this.$refs.myFiles.files[0]);
                this.uploadManual({
                    id: this.id,
                    data: formData
                })
            }
        },
        downloadManual() {
            this.apiDownloadManual({id:this.id})
        },
        setupStartForm() {
            this.form.name = this.nameCompressor
            this.form.companyId = this.company_id==null?0:this.company_id
            this.form.type_controller = this.type_controller
            this.form.mac = this.mac
            this.form.date = this.date
            this.form.modem_mac = this.modem_mac
            this.form.sim_operator = this.sim_operator
            this.form.sim_qualit = this.sim_qualit
            this.form.wifi_ssid = this.wifi_ssid
            this.form.wifiSigna = this.wifiSigna
        }
    },
    created() {
        this.setupStartForm()
        if (this.nameCompressor) {
            this.nameWinow = this.nameCompressor
        } else {
            this.nameWinow = this.mac
        }
        if (this.userOptions.role != 'user' && this.userOptions.role != 'demo') {
            this.getCompanyList();
        }
    }
}
</script>
<style noscoped lang="scss">
.background-window{
    position: absolute;
    z-index: 2;
    top:0;
    left:0;
    background: rgba(0, 0, 0, 0.295);
    width: 100vw;
    height: 100vh;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
.window-param{
    background: var(--background-white, #FCFCFC);
    cursor: auto;
    // width: 398px;
    border-radius: 4px;
    padding: 12px 9px;
    display: flex;
    flex-direction: column;

    .head-window {
        display: flex;
        justify-content: space-between;

        button {
            padding: 1px 2px;
            background: none;
            cursor: pointer;
        }
    }
    .input-form-compressor {
        position: relative;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        
        .uploading-downloading-form {
            display: flex;
            flex-direction: column;
            padding: 10px 10px;
            border: 1px solid var(--gray-dark-color);
            border-radius: 4px;
            
            input {
                margin-bottom: 5px;
            }

        }
        
        // input {
        .name-compressor-input{
            padding: 3px 6px;
            width: 343px;
            min-width: 285px;
            padding: 3px 6px;
            border-radius: 4px;
            border: 1px solid var(--gray-dark-color, #949494);
        }

        label {
            order: -1;
            pointer-events: none;
            margin: 1px 1px;
            padding: 0 6px;
            // transform: translateY(20px);
            background: var(--background-white);
            transition: all .2s ease;
            left: 3px;
            border-radius: 4px;
            color: var(--gray-dark-color, #949494);
            position: absolute;
            // left: 6px;
            white-space: nowrap;
        }
        input:focus ~ label {
            // bottom: 100%;
            transform: translateY(-14px);
        }
        .active {
            transform: translateY(-14px);
        }
        
    }
    .body-window {
        align-self: center;
    }
    .button-place {
        margin-top: 26px;
        // display: flex;
        // flex-direction: column;

        button {
            transition: all .2s ease;
            box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.2);
        }
        button:hover {
            box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.2);
        }
        button:active {
            box-shadow: none;
        }
    }
    .button-form-compressor:first-child {
        margin-bottom: 11px;
    }
    .button-form-compressor {
        width: 100%;
        // padding: 5px 0px;
        // width: 343px;
        color: #FFF;
        cursor: pointer;
        // box-sizing: border-box;
        border-radius: 8px;
        padding: 6px 0px;
        transition: all ease .3s;
    }
    .red-color {
            background: var(--red-color, #F97676); 
        }
    .blue-color {
        background: var(--background-blue, #3F51B5);
    }
    .button-go-to-modem {
        margin-left: 10px;
        padding: 0px 10px;
        background: var(--background-white, #FCFCFCFF);
        border: 1px solid var(--gray-colo, #EDEDEDFF);
        border-radius: 4px;

        &:hover {
            background: rgb(223, 223, 223);
        }
        &:active {
            background: rgb(200, 200, 200);
        }
    }
}
@media screen and (max-width: 420px) {
    .window-param{
        width: 361px;
        .input-form-compressor {
            input {
                width: 297px;
            }
        }
        .button-form-compressor {
            width: 297px;
        }
        .middle-high {
            font-family: Lato;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }
}

</style>